// TODO: change both urls when these screens are made

export const SEARCH_PARAMS_KEYS = {
  verificationId: 'verificationId',
  verificationRequestId: 'verificationRequestId',
  componentId: 'componentId',
  claimId: 'claimId',
  clientContractId: 'clientContractId',
  applicantId: 'applicantId',
  transactionID: 'transactionID',
  skipEducation: 'skipEducation',
  skipProfession: 'skipProfession',
  skipSelectComponent: 'skipSelectComponent',
  token: 'token',
  applicantUserId: 'applicantUserId',
  country: 'country',
  authority: 'authority',
  title: 'title',
  caseId: 'caseId',
  redirectUrl: 'redirectUrl',
  source: 'source',
  categoryId: 'categoryId',
  purposeId: 'purposeId',
  purposeCategoryId: 'purposeCategoryId',
  orderId: 'orderId',
  redirect: 'redirect',
  adId: 'adId',
  code: 'code',
  uaePassState: 'state',
  error: 'error',
  errorDescription: 'error_description',
  type: 'type',
  originalVerificationRequestId: 'originalVerificationRequestId',
  documentId: 'documentId',
  passportNo: 'passportNo',
  dob: 'dob',
  email: 'email',
  phoneNo: 'phoneNo',
  parentVerificationRequestId: 'parentVerificationRequestId',
  paymentTransactionId: 'paymentTransactionId',
  redirectAfterFetchReport: 'redirectAfterFetchReport',
  clientShortCode: 'clientShortCode',
  isDrawerOpen: 'is-drawer-open',
  isMigrationFlow: 'isMigrationFlow',
  subscriptionId: 'subscriptionId',
  planId: 'planId',
  status: 'status',
  paymentContractId: 'paymentContractId',
  credentialId: 'credentialId',
  isOnlyAdditionalDocumentVerificationAllowed:
    'isOnlyAdditionalDocumentVerificationAllowed',
  additionalClientIds: 'additionalClientIds',
  allowedVRStatuses: 'allowedVRStatuses',
  partnerInvite: 'partnerInvite',
  countryName: 'countryName',
  countryFlagUrl: 'countryFlagUrl',
  clientName: 'clientName',
  clientLogoUrl: 'clientLogoUrl',
  purposeName: 'purposeName',
  purposeCategoryName: 'purposeCategoryName',
  isAdditionalComponents: 'isAdditionalComponents',
  orderPaymentId: 'orderPaymentId',
  slf: 'slf',
  dfgOrderId: 'dfgOrderId'
};

export const PAGE_URLS = {
  faq: 'https://support.dataflowgroup.com/',
  home: '/dashboard/home',
  verification: '/dashboard/verification',
  onboardingAddEmail: '/onboarding/add-email',
  onboardingAddAboutYourself: '/onboarding/about-yourself',
  onBoardinSignin: '/onboarding/signin',
  onboardingVerificationMobile: '/onboarding/verification/mobile',
  onboardingVerificationMobileWithParams:
    '/onboarding/verification/mobile?token=#{token}&redirect=#{redirect}',
  onboardingVerificationEmail: '/onboarding/verification/email',
  vip: 'https://www.dataflowgroup.com/vip/',
  splash: '/onboarding/splash',
  aboutUsWhoWeAre: 'https://www.dataflowgroup.com/about-us/who-we-are/',
  termsAndConditions: 'https://www.dataflowgroup.com/terms-conditions/',
  privacyPolicy:
    'https://www.dataflowgroup.com/about-us/our-policies/general-applicant-privacy-policy/',
  accessSupport: 'https://support.dataflowgroup.com/',
  trackSupportTicket: 'https://support.dataflowgroup.com/?token=#{token}',
  signInError: '/onboarding/signin/error',
  contactDetails: '/verification/contact-details',
  languagePreference: '/dashboard/manage-account/language-preference'
};

export const VERIFICATION_URLS = {
  selectCountry: '/verification/select-country',
  selectAuthority: '/verification/select-authority',
  addSpeciality: '/verification/add-speciality',
  pqrSelection: '/verification/pqrSelection',
  browseExistingCases: '/verification/browseExistingCases',
  iaAttribution: '/verification/ia-attribution',
  requiredDocuments: '/verification/required-documents',
  selectDocuments: '/verification/select-documents',
  selectIssuers: '/verification/select-issuers',
  overviewSummary:
    '/verification/overview-summary?verificationRequestId=#{verificationRequestId}',
  overview:
    '/verification/overview?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  pricingDetailsUrl: `/verification/pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}`,
  verificationInsufficiency: `/verification/verification-insufficiency?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  verificationInsufficiencyOverview: `/verification/verification-insufficiency/overview?verificationId=#{verificationId}&applicantUserId=#{applicantUserId}`,
  uploadDocumentsForVerification:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&isMigrationFlow=#{isMigrationFlow}',
  clientRequirementListTab:
    '/verification/client-requirement-list-tab?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&applicantUserId=#{applicantUserId}',
  uploadDocumentsForEditComponent:
    '/verification/document-upload?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  pricingEstimation:
    '/verification/pricing-estimate?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&componentId=#{componentId}',
  insufficiencyPricingEstimation:
    '/verification/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&insufficiency=true',
  letterOfAuth: `/verification/letter-of-auth?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&isMigrationFlow=#{isMigrationFlow}`,
  VRSuccess: '/verification/vr-success',
  appealRequest:
    '/verification/appeal-request?verificationRequestId=#{verificationRequestId}',
  requestCorrection:
    '/verification/request-correction?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&caseId=#{caseId}',
  paymentStatus:
    '/verification/payment-status?PaymentTransactionId=#{PaymentTransactionId}&paymentStatus=#{paymentStatus}&verificationRequestId=#{verificationRequestId}',
  additionalComponents:
    '/verification/additional-components?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&parentVerificationRequestId=#{parentVerificationRequestId}',
  reportTransfer:
    '/verification/report-transfer?verificationRequestId=#{verificationRequestId}&skipEducation=#{skipEducation}&skipProfession=#{skipProfession}&applicantUserId=#{applicantUserId}&skipSelectComponent=#{skipSelectComponent}',
  nameChange:
    '/verification/name-change?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  findReport: `/verification/find-report?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  reportDocumentDetails: `/verification/find-report/report-document-details?documentId=#{documentId}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  fetchReportDetails: `/verification/find-report/fetch-report-details?${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  VerifyReportDetails:
    '/verification/find-report/verify-report-details?passportNo=#{passportNo}&dob=#{dob}&email=#{email}&phoneNo=#{phoneNo}&verificationRequestId=#{verificationRequestId}',
  existingReports: `/verification/find-report/existing-reports?passportNo=#{passportNo}&dob=#{dob}&${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}=#{${SEARCH_PARAMS_KEYS.redirectAfterFetchReport}}`,
  submitApplication: `/verification/submit-application?verificationRequestId=#{verificationRequestId}`,
  fetchReportPricing:
    '/verification/fetch-report-pricing?verificationRequestId=#{verificationRequestId}',
  fetchReportReissuePricing:
    '/verification/reissue-report?verificationRequestId=#{verificationRequestId}',
  additionalAuthentication:
    '/verification/additional-authentication?type=#{type}&verificationRequestId=#{verificationRequestId}&error=#{error}',
  approvalSent: `/verification/approval-sent?verificationRequestId=#{verificationRequestId}`,
  addSpecialityUrl:
    '/verification/add-speciality?authority=#{authority}&country=#{country}',
  pqrSelectionUrl:
    '/verification/pqrSelection?authority=#{authority}&country=#{country}',
  AncillaryInterstitial: '/verification/ancillary-interstitial'
};

export const DASHBOARD_URLS = {
  credential: `/dashboard/vault/identity`,
  addCreditional: `/dashboard/vault/add-identity`,
  vault: `/dashboard/vault`,
  verificationDetails: `/dashboard/verification/verification-details?verificationId=#{verificationId}`,
  VERIFICATION_UPDATE: `/dashboard/verification/update?verificationId=#{verificationId}`,
  userProfile: '/dashboard/user-profile',
  transactions: '/dashboard/transactions',
  manageAccount: '/dashboard/manage-account',
  notificationPreferences:
    '/dashboard/manage-account/notification-preferences?title=#{title}',
  accountOption: '/dashboard/account-option',
  notificationCategory: '/dashboard/notification-category',
  services: `/dashboard/services/?source=#{source}`,
  partnerHomePage: '/dashboard/home',
  subscriptionPaymentBreakdown:
    '/dashboard/vault/subscription-payment?planId=#{planId}&subscriptionId=#{subscriptionId}'
};

export const DASHBOARD_URL_QUERY_PARAMS = {
  component: 'component'
};

export const VERIFICATION_EXTRA_URLS = {
  icon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/svg`,
  countryIcon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images`,
  documentIcon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/docs`,
  purposeIcon: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/purpose`,
  country: 'country',
  authority: 'authority',
  addSpeciality: 'add-speciality',
  pqrSelection: 'pqrSelection'
};

export const UNAUTHENTICATED_PAGE_URLS = [
  '/onboarding/signin',
  '/onboarding/verification/mobile',
  '/onboarding/splash',
  '/onboarding/auth/error',
  '/services/ad-details',
  '/services/category',
  '/dashboard/services',
  '/validate-trueproof'
];

export const NOTIFICATIONS_URLS = {
  home: '/dashboard/home/notifications',
  noNotificationImgPath: '/assets/image/amico.png'
};

export const LEAD_MANAGEMENT_URLS = {
  category: `services/category?source=#{source}&categoryId=#{categoryId}`,
  adDetails: `/services/ad-details?adId=#{adId}`,
  servicesBySource: `/dashboard/services?source=#{source}`,
  ancillaryPaymentStatus: '/services/payment-status?dfgOrderId=#{orderId}',
  ancillaryPaymentBreakdown: '/services/payment-breakdown?orderId=#{orderId}'
};

export const DATAFLOW_LOGO_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/dataFlowLogo.png`;

export const KUBER_BFF_PREFIX = 'kapi';

export const EMPTY_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/ZeroResults.png`;

export const NO_PAST_RECORDS_IMG_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/noPastReports.png`;

export const VALID_FILE_TYPES = ['PNG', 'JPG', 'PDF', 'JPEG'];
export const BULK_UPLOAD_VALID_FILE_TYPES = [
  'PNG',
  'JPG',
  'PDF',
  'JPEG',
  'ZIP'
];

/**
 * Values for the `source` search param, used to signal which flow initiated a
 * navigation (e.g. editing a CRL from the verification overview).
 */
export const NAVIGATION_SOURCES = {
  overview: 'overview'
} as const;
